import React, { useContext } from 'react';
import classnames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { RecommendationsInspireGrid } from '@fiverr-private/inspire_listings';
import { CollectionsContext } from '../context/CollectionsContext';
import { COPIES_PREFIX } from '../constants';
import type { RecommendationsGridProps } from './types';

import classes from './RecommendationsGrid.module.scss';

export const RecommendationsGrid = ({ inspireDeliveryId }: RecommendationsGridProps) => {
  const [collections, setCollections] = useContext(CollectionsContext);

  const title = translate(`${COPIES_PREFIX}.find_your_inspiration`);

  const inspireDeliveryIdsSaved = [inspireDeliveryId];

  return (
    <>
      <h3 className={classnames(classes.title, 't-a-center')}>{title}</h3>
      <RecommendationsInspireGrid
        isTouch
        collections={collections || []}
        onUpdateCollections={setCollections}
        mixpanelEnabled
        mixpanelOptions={{
          pageName: 'Inspire Delivery Page',
          hostingScreen: 'Inspire Delivery Page',
          component: 'Recommended Deliveries Waterfall',
        }}
        inspireDeliveryIdsSaved={inspireDeliveryIdsSaved}
        shouldHideSavedDeliveries
        mixpanelRecommendationsEnabled
        mixpanelRecommendationsOptions={{
          pageName: 'Inspire Delivery Page',
          carouselName: 'Goals Expansion',
        }}
        bigQueryEnabled
        bigQueryOptions={{
          pageName: 'delivery_page',
        }}
      />
    </>
  );
};
